import {useState} from 'react';
import {Input} from 'antd';

export const NameChangeWidget = ({name, onNameSave, props}) => {
    const [active, setActive] = useState(false);
    const [value, setValue] = useState(undefined);

    const onClick = () => {
        setValue(name)
        setActive(true);
    }

    const onChange = (e) => {
        setValue(e.target.value);
    }

    const sendName = () => {
        if (onNameSave) {
            // do not allow empty string
            const newValue = (value === "") ? "NoName" : value
            onNameSave(newValue);
        }
    }

    const onBlur = () => {
        sendName();
        setActive(false);
    }

    const onMouseLeave = () => {
        sendName();
        setActive(false);
    }

    const divStyle = {
        cursor: 'pointer'
    }

    if (active === false) {
        return <div style={divStyle} onClick={onClick}>
            <b>
                {name}
            </b>
        </div>
    } else {
        return <Input value={value} onChange={onChange} onBlur={onBlur} onMouseLeave={onMouseLeave}/>
    }
}